import { toUpper, chain } from 'lodash';
import { Rule } from '../../containers/ContainerManagement/types';

const BLOCK_NAMES = new Set(['STOW BLOCK', 'PICK BLOCK', 'CC BLOCK']);

export const getBlocksFromRules = (rules: Rule[] | null): string[] => {
  if (!rules) return [];

  const blocks: string[] = [];
  rules.forEach((rule: Rule) => {
    if (BLOCK_NAMES.has(toUpper(rule.name))) {
      blocks.push(rule.name);
    }
  });
  return blocks.sort();
};

export const getStatus = (isActive: string): string => {
  return isActive;
};

export const transformDataForMultiselectDropdown = (locationResponse: any): any => {
  const locationData: { label: any; value: any; locationId: any }[] = [];
  Object.keys(locationResponse).forEach((loc) => {
    locationData.push({
      label: locationResponse[loc].locationName,
      value: locationResponse[loc].locationName,
      locationId: locationResponse[loc].locationId,
    });
  });
  return (
    chain(locationData)
      // Group the elements of Array based on `color` property
      .groupBy((item) => {
        return item.label.substr(0, 3);
      })
      // `key` is group's name (color), `value` is the array of objects
      .map((value, key) => ({ label: key, options: value }))
      .value()
  );
};
